import $ from 'jquery'
import _ from 'underscore'
import TemplateView from '../../../TemplateView'
import Month from './month/Month'
import {geSelectedYear, getCorporateDaysForSelectedYear, getDefaultWorkSchedule, getLeaveBlackoutDaysForSelectedYear} from '../selectors'
import {addCorporateDay, addLeaveBlackoutDay, deleteCorporateDay, deleteLeaveBlackoutAndAddCorporateDay, deleteLeaveBlackoutDay} from '../actions'
import {connect} from '../../../redux/utils'
import {dayStatuses, WORK_SCHEDULE_YEAR_START} from '../constants'
import {bindActionCreators} from 'redux'
import CorporateHolidayEditor from './month/CorporateHolidayEditor'
import messageResource from '../../../messageResource'
import RegularNonWorkingDayEditor from './month/RegularNonworkingDayEditor'
import SimpleDiv from '../../../components/SimpleDiv'
import {canManageSystemSettings} from '../../../loggedInUser/selectors'
import WorkingDayEditor from './month/WorkingDayEditor'
import ConfirmationDropdown from './month/ConfirmationDropdown'

class Calendar extends TemplateView {
    constructor({
        leaveBlackoutEnabled,
        addCorporateDay = () => {},
        deleteCorporateDay = () => {},
        addLeaveBlackoutDay = () => {},
        deleteLeaveBlackoutDay = () => {},
        deleteLeaveBlackoutAndAddCorporateDay = () => {},
    }) {
        super()

        this.actions = {
            addCorporateDay,
            deleteCorporateDay,
            addLeaveBlackoutDay,
            deleteLeaveBlackoutDay,
            deleteLeaveBlackoutAndAddCorporateDay,
        }

        this.state = {
            defaultWorkSchedules: [],
            corporateDays: {},
            leaveBlackoutDays: {},
            selectedYear: WORK_SCHEDULE_YEAR_START,
            canManage: false,
            leaveBlackoutEnabled,
        }

        this.months = {}

        this._leaveBlackoutEnabled = leaveBlackoutEnabled

        this.onAnyStatePropertyChanged(['defaultWorkSchedules', 'selectedYear', 'canManage'], () => this.updateCalendar())

        this.onAnyStatePropertyChanged(['corporateDays', 'leaveBlackoutDays'], () => {
            if (_.size(this.months) > 0) {
                for (let i = 0; i < 12; i++) {
                    let monthDate = new Date(this.state.selectedYear, i)
                    let corporateDays = {}
                    let leaveBlackoutDays = {}
                    if (this.state.corporateDays) {
                        corporateDays = this.state.corporateDays[i] || {}
                    }
                    if (this.state.leaveBlackoutDays) {
                        leaveBlackoutDays = this.state.leaveBlackoutDays[i] || {}
                    }
                    this.months[monthDate].setState({
                        corporateDays: corporateDays,
                        leaveBlackoutDays: leaveBlackoutDays
                    })
                }
            }
        })
    }

    templateHtml() {
        return '<div class="monthsContainer">' +
               '</div>'
    }

    afterRender() {
        this.confirmationDropdown = new ConfirmationDropdown().init($('body'))

        this.updateCalendar()
    }

    updateCalendar() {
        this.getEl().empty()
        let currentDate = window.currentUserTime()
        currentDate.clearTime()

        if (this.state.defaultWorkSchedules.length > 0) {
            for (let i = 0; i < 12; i++) {
                let monthDate = new Date(this.state.selectedYear, i)

                let month = new Month({
                    firstMonthDate: monthDate.getFirstDateOfMonth(),
                    weekStartDay: SystemSettings.weekStartDay,
                    defaultWorkSchedules: this.state.defaultWorkSchedules,
                    currentDate: currentDate,
                    editable: this.state.canManage,
                    onDayClick: (day, date, nonWorking, leaveBlackout, status, title) => this.handleDayClick(day, date, nonWorking, leaveBlackout, status, title),

                }).init(this.getEl())

                let corporateDays = {}
                let leaveBlackoutDays = {}

                if (this.state.corporateDays) {
                    corporateDays = this.state.corporateDays[i] || {}
                }
                if (this.state.leaveBlackoutDays) {
                    leaveBlackoutDays = this.state.leaveBlackoutDays[i] || {}
                }
                month.setState({
                    corporateDays: corporateDays,
                    leaveBlackoutDays: leaveBlackoutDays
                })

                this.months[monthDate] = month
            }
        }

        //add empty month elements for proper positioning
        for (let n = 0; n < 4; n++) {
            new SimpleDiv({
                additionalClass: 'components_month emptyMonth',
            }).init(this.getEl())
        }

        const $body = $('body')
        this.corporateHolidayEditor = new CorporateHolidayEditor({
            editCallback: (date, isWorking, title) => this.actions.addCorporateDay(date, isWorking, title),
            deleteCallback: (date) => this.actions.deleteCorporateDay(date),
        }).init($body)

        this.regularNonworkingDayEditor = new RegularNonWorkingDayEditor({
            leaveBlackoutEnabled: this._leaveBlackoutEnabled,
            editCorporateCallback: (date, isWorking, title, isLeaveBlackout) => {
                if (isLeaveBlackout && !isWorking)
                    this.actions.deleteLeaveBlackoutAndAddCorporateDay(date, isWorking, title)
                else
                    this.actions.addCorporateDay(date, isWorking, title)
            },
            deleteCorporateCallback: (date) => this.actions.deleteCorporateDay(date),
            addLeaveBlackoutCallback: (date) => this.actions.addLeaveBlackoutDay(date),
            deleteLeaevBlackoutCallback: (date) => this.actions.deleteLeaveBlackoutDay(date),
            openDeleteNonApprovedLeaveRequestsConfirmationCallback: (element, date, nonApprovedLeaveRequestsCount) => this._openDeleteNonApprovedLeaveRequestsConfirmation(element, date, nonApprovedLeaveRequestsCount)
        }).init($body)

        this.workingDayEditor = new WorkingDayEditor({
            leaveBlackoutEnabled: this._leaveBlackoutEnabled,
            addCorporateCallback: (date, isLeaveBlackout) => {
                if (isLeaveBlackout)
                    this.actions.deleteLeaveBlackoutAndAddCorporateDay(date, false, messageResource.getMessage('work_schedule.corporate_holiday'))
                else
                    this.actions.addCorporateDay(date, false, messageResource.getMessage('work_schedule.corporate_holiday'))
            },
            deleteCorporateCallback: (date) => this.actions.deleteCorporateDay(date),
            addLeaveBlackoutCallback: (date) => this.actions.addLeaveBlackoutDay(date),
            deleteLeaevBlackoutCallback: (date) => this.actions.deleteLeaveBlackoutDay(date),
            openDeleteNonApprovedLeaveRequestsConfirmationCallback: (element, date, nonApprovedLeaveRequestsCount) => this._openDeleteNonApprovedLeaveRequestsConfirmation(element, date, nonApprovedLeaveRequestsCount)
        }).init($body)
    }


    handleDayClick(day, date, nonWorking, isLeaveBlackout, status, title = '') {
        if (!nonWorking && status === dayStatuses.STANDARD_DAY) {
            this.workingDayEditor.setState({
                date,
                title,
                showMarkAsWorkingButton: nonWorking,
                isLeaveBlackout,
            })
            this._openEditor(this.workingDayEditor, day)
        } else if (status === dayStatuses.CORPORATE_HOLIDAY) {
            this.corporateHolidayEditor.setState({
                date,
                title,
                showMarkAsWorkingButton: nonWorking,
            })
            this._openEditor(this.corporateHolidayEditor, day)
        } else if (nonWorking) {
            this.regularNonworkingDayEditor.setState({
                date,
                nonStandardWorking: status === dayStatuses.NON_STANDARD_WORKING_DAY,
                isLeaveBlackout,
            })
            this._openEditor(this.regularNonworkingDayEditor, day)
        }
    }

    _openEditor(editor, day) {
        editor.setOnHideCallback(() => day.setState({ editing: false }))
        editor.setOnShowCallback(() => day.setState({ editing: true }))
        editor.showAt(day.$el)
    }

    _openDeleteNonApprovedLeaveRequestsConfirmation(element, date, nonApprovedLeaveRequestsCount) {
        this.confirmationDropdown.setProps(date, () =>  { this.actions.addLeaveBlackoutDay(date) }, nonApprovedLeaveRequestsCount)
        this.confirmationDropdown.showAt(element)
    }
}

export default connect(
    (state) => ({
        defaultWorkSchedules: getDefaultWorkSchedule(state),
        corporateDays: getCorporateDaysForSelectedYear(state),
        leaveBlackoutDays: getLeaveBlackoutDaysForSelectedYear(state),
        selectedYear: geSelectedYear(state),
        canManage: canManageSystemSettings(state),
    }),
    (dispatch) => ({
        addCorporateDay: bindActionCreators(addCorporateDay, dispatch),
        deleteCorporateDay: bindActionCreators(deleteCorporateDay, dispatch),
        addLeaveBlackoutDay: bindActionCreators(addLeaveBlackoutDay, dispatch),
        deleteLeaveBlackoutDay: bindActionCreators(deleteLeaveBlackoutDay, dispatch),
        deleteLeaveBlackoutAndAddCorporateDay: bindActionCreators(deleteLeaveBlackoutAndAddCorporateDay, dispatch),
    })
)(Calendar)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/Calendar.js